import { setConfiguration } from "@configuratorware/configurator-frontendgui/App/configuration";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import products from "./App/Reducers/Products/Reducer";
import login from "./App/Reducers/Login/Reducer";
import outfit from "./App/Reducers/Outfit/Reducer";
import customConfigurator from "./App/Reducers/Configurator/Reducer";
import basket from "./App/Reducers/Basket/Reducer";
import customImageGallery from "./App/Reducers/ImageGallery/Reducer";
const prod = process.env.NODE_ENV === "production";
import ConfiguratorScreen from "./App/Screens/ConfiguratorScreen";
import DesignerService from "./App/Services/DesignerService";
import InteractionService from "./App/Services/InteractionService";
import CustomVisualizationService from "./App/Services/VisualizationService";

const envDomains = {
  test: "",
  int: "http://int.schoeffel-teamwear.local",
  local: "",
  prod: "",
};
const domain = envDomains[prod ? "prod" : "int"];

const query = new URLSearchParams(location.search);

const adminMode = query.get("_adminmode");

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}/`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
  },
  reducers: {
    products: products,
    login: login,
    configurator: customConfigurator,
    basket: basket,
    imageGallery: customImageGallery,
    outfit: outfit,
  },
  showStartHere: false,
  reduxPersist: {
    enabled: true,
    storeConfig: {
      whitelist: ["login", "basket"],
    },
  },
  services: {
    DesignerService,
    InteractionService,
    VisualizationService: CustomVisualizationService,
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader("no-cache");
}

export default customApplicationConfiguration;
